import VueRouter from "vue-router";
import Verification from "./views/Verification";
import ErrorPage from "./views/Error";

export default new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/verify/org/:organization",
            component: Verification,
            query: {
                msgDropHere: null,
                msgSuccess: null,
                msgFailed: null,
                msgAgainst: null,
                msgBrowse: null,
                hideBranding: null,
                hideLogo: null,
                hideOrganization: null,
                hideBorder: null,
            }
        },
        {
            path: "/verify/signer/:signer",
            component: Verification,
        },
        { path: '/error/:type', component: ErrorPage },
        { path: '*', component: ErrorPage },
    ]
})
